import { Menu, MenuItem, Popper, Tooltip } from '@material-ui/core';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PUFV_YELLOW_THEME } from '../../../../config/MaterialTheme';
import {
  CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL,
  CONTRATO_EDIT_ETAPA_ARQUIVOS,
  CONTRATO_EDIT_ETAPA_DADOS,
  CONTRATO_EDIT_ETAPA_VALIDACAO,
} from '../../../../library/ContratoEditEtapas';
import {
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_AGUARDANDO_EXTRATO,
  CONTRATO_STATUS_APROVADO,
  CONTRATO_STATUS_DESATIVADO,
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_NEGADO,
  CONTRATO_STATUS_VIGENTE,
} from '../../../../library/ContratoStatus';
import {
  CONTRATO_TIPO_ASSESSOR,
  CONTRATO_TIPO_ASSESSOR_NAME,
  CONTRATO_TIPO_ENTE_PRIVADO,
  CONTRATO_TIPO_ENTE_PRIVADO_NAME,
  CONTRATO_TIPO_ENTE_PUBLICO,
  CONTRATO_TIPO_ENTE_PUBLICO_NAME,
  FLUXO_TIPO_CENTRALIZADO,
  FLUXO_TIPO_CENTRALIZADO_NAME,
  FLUXO_TIPO_DESCENTRALIZADO,
  FLUXO_TIPO_DESCENTRALIZADO_NAME,
  FLUXO_TIPO_TODOS,
  FLUXO_TIPO_TODOS_NAME,
} from '../../../../library/ContratoTipos';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../library/ContratoVersoes';
import {
  contratoAditivoEditRoute,
  contratoAditivoEditRouteDescentralizado,
  contratoAditivoNovoRoute,
  contratoAditivoNovoRouteDescentralizado,
  contratoDistratoEditRoute,
  contratoDistratoEditRouteDescentralizado,
  contratoDistratoNovoRoute,
  contratoEditRoute,
  contratoEditRouteDescentralizado,
  createAditivoDescentralizadoRoute,
  createDistratoDescentralizadoRoute,
  editAditivoDescentralizadoRoute,
  editDistratoDescentralizadoRoute,
  newContratoDescentralizadoEditRoute,
} from '../../../../library/Routes';
import {
  getContratoTipoByContratoTipoNumber,
  getAllContratoStatusNumberByType,
  getContratoTipoByContratoDescentralizadoTipoNumber,
} from '../../../../utils/ContratoUtils';
import { getMergedClassNames } from '../../../../utils/HTMLUtils';
import styles from './ContratoItem.scss';
import BadgeCheck from 'assets/icons/BadgeCheck';
import BadgeClose from 'assets/icons/BadgeClose';
import BadgeEdit from 'assets/icons/BadgeEdit';
import BadgeClock from 'assets/icons/BadgeClock';
import {
  CONTRATO_ETAPAS_PARAMS_URL,
  CONTRATO_PASSOS,
  CONTRATO_FLUXO_DESCENTRALIZADO,
  TipoContrato,
  TipoFluxo,
  URL_ADITIVO_PARAM,
  URL_DISTRATO_PARAM,
  ContratoStatus,
} from '../../../../models/contratos';
import { Row } from 'components/Row';
import { Col } from 'components/Col';
import MoreVert from 'components/Icons/MoreVertIcon';
import { Tag } from 'components/Tag';
import moment from 'moment';
import AccordionAlert from 'assets/icons/AccordionAlert';

const rootClassName = styles.rootClassName;

export const ContratoItem = (props) => {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const languageValues = useSelector((state) => state.languages.languageValues);
  const auth = useSelector((state) => state.auth);
  const allStatus = getAllContratoStatusNumberByType(
    props.contrato.tipoContrato,
    auth,
    languageValues
  );
  const history = useHistory();

  const getStatusName = (status) => {
    switch (status) {
      case CONTRATO_STATUS_EM_EDICAO:
        return languageValues.contratoStatusEmEdicao;
      case CONTRATO_STATUS_EM_ANALISE:
        return languageValues.contratoStatusEmAnaliseOperacional;
      case CONTRATO_STATUS_NEGADO:
        return languageValues.contratoStatusRejeitado;
      case CONTRATO_STATUS_APROVADO:
        return languageValues.contratoStatusAprovado;
      case CONTRATO_STATUS_AGUARDANDO_ASSINATURA:
        return languageValues.contratoStatusAguardandoAssinatura;
      case CONTRATO_STATUS_AGUARDANDO_EXTRATO:
        return languageValues.contratoStatusExtrato;
      case CONTRATO_STATUS_NAO_INICIADO:
        return languageValues.contratoStatusNaoIniciado;
      case CONTRATO_STATUS_VIGENTE:
        return languageValues.contratoStatusVigente;
      case CONTRATO_STATUS_ENCERRADO:
        return languageValues.contratoStatusEncerrado;
      case CONTRATO_STATUS_DESATIVADO:
      default:
        return languageValues.contratoStatusDesativado;
    }
  };

  const allowMenu = () => {
    if (auth.userPermissions.contratos.assessor.edit) {
      switch (props.contrato.status) {
        case CONTRATO_STATUS_NAO_INICIADO:
        case CONTRATO_STATUS_VIGENTE:
          return true;
        default:
          return false;
      }
    }
  };

  const allowGeraAditivo = () => {
    return allowMenu() && props.contrato.geraAditivo;
  };

  const allowGeraDistrato = () => {
    return allowMenu() && props.contrato.geraDistrato;
  };

  const toOpenMenu = (event) => setMenuAnchor(event.currentTarget);

  const toCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleButtonClick = (button) => {
    const contrato = props.contrato;

    const getIdAditivoClicado = (buttonAditivo, contratoAditivo) => {
      const aditivo = contratoAditivo.aditivos.find(
        (aditivoItem) => aditivoItem.id === buttonAditivo.id
      );
      return aditivo ? aditivo.id : null;
    };

    const aditivoClicado = getIdAditivoClicado(button, contrato);

    const getIdDistratoClicado = (buttonDistrato, contratoDistrato) => {
      const distrato = contratoDistrato.distratos.find(
        (distratoItem) => distratoItem.id === buttonDistrato.id
      );
      return distrato ? distrato.id : null;
    };

    const distratoClicado = getIdDistratoClicado(button, contrato);

    let etapa = CONTRATO_EDIT_ETAPA_VALIDACAO;
    if (
      button.ativo &&
      button.status === CONTRATO_STATUS_EM_ANALISE &&
      auth.userPermissions.contratos.assessor.analiseOperacional.edit
    ) {
      etapa = CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL;
    }

    let url = '';

    if (contrato.tipoFluxo === FLUXO_TIPO_CENTRALIZADO) {
      switch (button.versaoContrato) {
        case CONTRATO_VERSAO_ADITIVO:
          url = contratoAditivoEditRoute.getURLWithParams(
            getContratoTipoByContratoTipoNumber(contrato.tipoContrato),
            contrato.id,
            button.id,
            etapa
          );
          break;
        case CONTRATO_VERSAO_DISTRATO:
          url = contratoDistratoEditRoute.getURLWithParams(
            getContratoTipoByContratoTipoNumber(contrato.tipoContrato),
            contrato.id,
            button.id,
            etapa
          );
          break;
        case CONTRATO_VERSAO_CONTRATO:
        default:
          url = contratoEditRoute.getURLWithParams(
            getContratoTipoByContratoTipoNumber(contrato.tipoContrato),
            contrato.id,
            etapa
          );
          break;
      }
    } else {
      etapa = CONTRATO_EDIT_ETAPA_ARQUIVOS;
      const ADITIVO_PARAM = URL_ADITIVO_PARAM.MODAL_EDICAO_ADITIVO;
      const DISTRATO_PARAM = URL_DISTRATO_PARAM.MODAL_EDICAO_DISTRATO;
      switch (button.versaoContrato) {
        case CONTRATO_VERSAO_ADITIVO:
          if (contrato.tipoContrato === TipoContrato.ASSESSOR) {
            url = editAditivoDescentralizadoRoute.getURLWithParams(
              CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR,
              CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
              contrato.id,
              CONTRATO_PASSOS.DOCUMENTOS,
              aditivoClicado,
              URL_ADITIVO_PARAM.VERSAO,
              ADITIVO_PARAM
            );
          } else if (contrato.tipoContrato === TipoContrato.ENTE_PUBLICO) {
            url = editAditivoDescentralizadoRoute.getURLWithParams(
              CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO,
              CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
              contrato.id,
              CONTRATO_PASSOS.DOCUMENTOS,
              aditivoClicado,
              URL_ADITIVO_PARAM.VERSAO,
              ADITIVO_PARAM
            );
          } else if (contrato.tipoContrato === TipoContrato.ENTE_PRIVADO) {
            url = editAditivoDescentralizadoRoute.getURLWithParams(
              CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PRIVADO,
              CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
              contrato.id,
              CONTRATO_PASSOS.DOCUMENTOS,
              aditivoClicado,
              URL_ADITIVO_PARAM.VERSAO,
              ADITIVO_PARAM
            );
          } else {
            url = contratoAditivoEditRouteDescentralizado.getURLWithParams(
              getContratoTipoByContratoDescentralizadoTipoNumber(
                contrato.tipoContrato
              ),
              contrato.id,
              button.id,
              etapa
            );
          }
          break;
        case CONTRATO_VERSAO_DISTRATO:
          if (contrato.tipoContrato === TipoContrato.ASSESSOR) {
            url = editDistratoDescentralizadoRoute.getURLWithParams(
              CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR,
              CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
              contrato.id,
              CONTRATO_PASSOS.DOCUMENTOS,
              distratoClicado,
              URL_DISTRATO_PARAM.VERSAO,
              DISTRATO_PARAM
            );
          } else if (contrato.tipoContrato === TipoContrato.ENTE_PUBLICO) {
            url = editDistratoDescentralizadoRoute.getURLWithParams(
              CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO,
              CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
              contrato.id,
              CONTRATO_PASSOS.DOCUMENTOS,
              distratoClicado,
              URL_DISTRATO_PARAM.VERSAO,
              DISTRATO_PARAM
            );
          } else if (contrato.tipoContrato === TipoContrato.ENTE_PRIVADO) {
            url = editDistratoDescentralizadoRoute.getURLWithParams(
              CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PRIVADO,
              CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
              contrato.id,
              CONTRATO_PASSOS.DOCUMENTOS,
              distratoClicado,
              URL_DISTRATO_PARAM.VERSAO,
              DISTRATO_PARAM
            );
          } else {
            url = contratoDistratoEditRouteDescentralizado.getURLWithParams(
              getContratoTipoByContratoDescentralizadoTipoNumber(
                contrato.tipoContrato
              ),
              contrato.id,
              button.id,
              etapa
            );
          }
          break;
        case CONTRATO_VERSAO_CONTRATO:
          if (contrato.tipoContrato === TipoContrato.ASSESSOR) {
            url = newContratoDescentralizadoEditRoute.getURLWithParams(
              CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR,
              CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
              contrato.id,
              CONTRATO_PASSOS.DOCUMENTOS
            );
          } else if (contrato.tipoContrato === TipoContrato.ENTE_PUBLICO) {
            url = newContratoDescentralizadoEditRoute.getURLWithParams(
              CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO,
              CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
              contrato.id,
              CONTRATO_PASSOS.DOCUMENTOS

            );
          } else if (contrato.tipoContrato === TipoContrato.ENTE_PRIVADO) {
            url = newContratoDescentralizadoEditRoute.getURLWithParams(
              CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PRIVADO,
              CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
              contrato.id,
              CONTRATO_PASSOS.DOCUMENTOS
            );
          }
          else {
            url = contratoEditRouteDescentralizado.getURLWithParams(
              getContratoTipoByContratoDescentralizadoTipoNumber(
                contrato.tipoContrato
              ),
              contrato.id,
              etapa
            );
          }
          break;
        default:
      }
    }
    if (window.innerWidth >= 768) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  };

  const getDadosByArr = (items) => {
    return items.map((item, index) => {
      return (
        <div
          className={getMergedClassNames([rootClassName + '-item-label'])}
          key={index}
        >
          <span className={rootClassName + '-item-value'}>{item.label}:</span>{' '}
          {item.value}
        </div>
      );
    });
  };

  const getDadosEntePublico = useCallback(() => {
    return getDadosByArr([{
      label: languageValues.cidade,
      value: props.contrato.cidade + ' - ' + props.contrato.estado,
    }]);
  }, [props.contrato.cidade, props.contrato.estado, languageValues.cidade]);

  const getDadosEntePrivado = useCallback(() => {
    return getDadosByArr([{
      label: languageValues.escola,
      value: props.contrato.escola,
    }, {
      label: languageValues.cidade,
      value: props.contrato.cidade + ' - ' + props.contrato.estado,
    }]);
  }, [props.contrato.escola,
  props.contrato.cidade,
  props.contrato.estado,
  languageValues.cidade,
  languageValues.escola
  ]);

  const getDadosAssessores = useCallback(() => {
    return getDadosByArr([{
      label: languageValues.assessoresPedagogicos,
      value: getNomesAssessores(props.contrato.assessores),
    }]);
  }, [props.contrato.assessores, languageValues.assessoresPedagogicos]);

  const getDados = useCallback(() => {
    switch (props.contrato.tipoContrato) {
      case CONTRATO_TIPO_ENTE_PUBLICO:
        return getDadosEntePublico();
      case CONTRATO_TIPO_ENTE_PRIVADO:
        return getDadosEntePrivado();
      case CONTRATO_TIPO_ASSESSOR:
      default:
        return getDadosAssessores();
    }
  }, [props.contrato.tipoContrato, getDadosEntePublico, getDadosEntePrivado, getDadosAssessores]);

  const statusIcons = {
    [CONTRATO_STATUS_APROVADO]: (
      <BadgeCheck className='badgeIcon' color='#146E37' />
    ),
    [CONTRATO_STATUS_VIGENTE]: (
      <BadgeCheck className='badgeIcon' color='#146E37' />
    ),
    [CONTRATO_STATUS_ENCERRADO]: (
      <BadgeClose className='badgeIcon' color='#730028' />
    ),
    [CONTRATO_STATUS_NAO_INICIADO]: (
      <BadgeClock className='badgeIcon' color='#323C32' />
    ),
    [CONTRATO_STATUS_NEGADO]: (
      <BadgeClose className='badgeIcon' color='#730028' />
    ),
    [CONTRATO_STATUS_DESATIVADO]: (
      <BadgeClose className='badgeIcon' color='#730028' />
    ),
    [CONTRATO_STATUS_EM_EDICAO]: (
      <BadgeEdit className='badgeIcon' color='#5A3C1E' />
    ),
    [CONTRATO_STATUS_EM_ANALISE]: (
      <BadgeClock className='badgeIcon' color='#323C32' />
    ),
    [CONTRATO_STATUS_AGUARDANDO_ASSINATURA]: (
      <BadgeClock className='badgeIcon' color='#323C32' />
    ),
    [CONTRATO_STATUS_AGUARDANDO_EXTRATO]: (
      <BadgeClock className='badgeIcon' color='#323C32' />
    ),
  };

  const getButtonItem = (button, index) => {
    let children = 'Nº: ' + button.codigo;
    if (button.disabled) {
      children = children + ' - Desativado';
    }
    const statusBadge = !button.disabled && (
      <span
        className={`badge ${getStatusBadgeClass(button.status)}`}
        style={{ textDecoration: 'none' }}
      >
        {statusIcons[button.status]} {getStatusName(button.status)}
      </span>
    );
    return (
      <button
        className={getMergedClassNames([
          rootClassName + '-item-button',
          button.disabled ? rootClassName + '-disabled-item-button' : '',
        ])}
        onClick={() => handleButtonClick(button)}
        key={index}
      >
        {children}
        {statusBadge}
      </button>
    );
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case CONTRATO_STATUS_NEGADO:
        return 'badge-danger';
      case CONTRATO_STATUS_APROVADO:
        return 'badge-success';
      case CONTRATO_STATUS_EM_EDICAO:
        return 'badge-warning';
      case CONTRATO_STATUS_EM_ANALISE:
        return 'badge-info';
      case CONTRATO_STATUS_AGUARDANDO_ASSINATURA:
        return 'badge-info';
      case CONTRATO_STATUS_AGUARDANDO_EXTRATO:
        return 'badge-info';
      case CONTRATO_STATUS_NAO_INICIADO:
        return 'badge-info';
      case CONTRATO_STATUS_VIGENTE:
        return 'badge-success';
      case CONTRATO_STATUS_ENCERRADO:
        return 'badge-danger';
      case CONTRATO_STATUS_DESATIVADO:
      default:
        return '';
    }
  };

  const getNomesAssessores = (assessores) => {
    return assessores.join(', ');
  };

  const getAditivosByAllowedStatus = (aditivos) => {
    return aditivos.filter(
      (aditivo) => allStatus.indexOf(aditivo.flgStatus) > -1
    );
  };

  const getDistratosByAllowedStatus = (distratos) => {
    return distratos.filter(
      (distrato) => allStatus.indexOf(distrato.flgStatus) > -1
    );
  };

  const getButtonItems = () => {
    let buttons = [
      {
        versaoContrato: CONTRATO_VERSAO_CONTRATO,
        codigo: props.contrato.codigo,
        assessorName: getNomesAssessores(props.contrato.assessores),
        status: props.contrato.status,
        id: props.contrato.id,
        disabled: !props.contrato.ativo,
      },
    ];
    getAditivosByAllowedStatus(props.contrato.aditivos).map(
      (aditivo, index) => {
        buttons.push({
          versaoContrato: CONTRATO_VERSAO_ADITIVO,
          codigo: aditivo.codigo,
          status: aditivo.flgStatus,
          id: aditivo.id,
          disabled: !props.contrato.ativo || !aditivo.ativo,
        });
        return index;
      }
    );
    getDistratosByAllowedStatus(props.contrato.distratos).map(
      (distrato, index) => {
        buttons.push({
          versaoContrato: CONTRATO_VERSAO_DISTRATO,
          codigo: distrato.codigo,
          status: distrato.flgStatus,
          id: distrato.id,
          disabled: !props.contrato.ativo || !distrato.ativo,
        });
        return index;
      }
    );
    return buttons.map((button, index) => {
      return getButtonItem(button, index);
    });
  };

  const criarAditivo = () => {
    const { contrato } = props;
    const { tipoContrato, tipoFluxo, id } = contrato;
    const MODAL_CRIACAO_ADITIVO_PARAM = URL_ADITIVO_PARAM.MODAL_CRIACAO_ADITIVO

    const openInNewTab = (url) => window.open(url, '_blank');
    const pushToHistory = (url) => history.push(url);

    const urlDescentralizado = createAditivoDescentralizadoRoute.getURLWithParams(
      CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR,
      CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
      id,
      CONTRATO_PASSOS.DOCUMENTOS,
      MODAL_CRIACAO_ADITIVO_PARAM
    );

    const urlEntePublicoDescentralizado = createAditivoDescentralizadoRoute.getURLWithParams(
      CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO,
      CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
      id,
      CONTRATO_PASSOS.DOCUMENTOS,
      MODAL_CRIACAO_ADITIVO_PARAM
    );

    const urlEntePrivadoDescentralizado = createAditivoDescentralizadoRoute.getURLWithParams(
      CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PRIVADO,
      CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
      id,
      CONTRATO_PASSOS.DOCUMENTOS,
      MODAL_CRIACAO_ADITIVO_PARAM
    );

    const urlCentralizado = contratoAditivoNovoRoute.getURLWithParams(
      getContratoTipoByContratoTipoNumber(tipoContrato),
      id,
      CONTRATO_EDIT_ETAPA_DADOS
    );

    const urlDescentralizadoNum = contratoAditivoNovoRouteDescentralizado.getURLWithParams(
      getContratoTipoByContratoDescentralizadoTipoNumber(tipoContrato),
      id,
      CONTRATO_EDIT_ETAPA_DADOS
    );

    if (window.innerWidth >= 768) {
      if (
        (tipoContrato === TipoContrato.ASSESSOR ||
          tipoContrato === TipoContrato.ENTE_PUBLICO ||
          tipoContrato === TipoContrato.ENTE_PRIVADO) &&
        tipoFluxo === TipoFluxo.DESCENTRALIZADO
      ) {
        openInNewTab(tipoContrato === TipoContrato.ASSESSOR
          ? urlDescentralizado
          : tipoContrato === TipoContrato.ENTE_PUBLICO
            ? urlEntePublicoDescentralizado
            : urlEntePrivadoDescentralizado);
        return;
      }
    } else {
      pushToHistory(tipoContrato === TipoContrato.ASSESSOR
        ? urlDescentralizado
        : tipoContrato === TipoContrato.ENTE_PUBLICO
          ? urlEntePublicoDescentralizado
          : urlEntePrivadoDescentralizado);
    }

    if (window.innerWidth >= 768) {
      if (tipoFluxo === TipoFluxo.CENTRALIZADO) {
        openInNewTab(urlCentralizado);
      } else {
        pushToHistory(urlDescentralizadoNum);
      }
    }
  };

  const criarDistrato = () => {
    const { contrato } = props;
    const { tipoContrato, tipoFluxo, id } = contrato;
    const MODAL_CRIACAO_DISTRATO_PARAM = URL_DISTRATO_PARAM.MODAL_CRIACAO_DISTRATO;

    const openInNewTab = (url) => window.open(url, '_blank');
    const pushToHistory = (url) => history.push(url);

    const urlDescentralizado = createDistratoDescentralizadoRoute.getURLWithParams(
      CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR,
      CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
      id,
      CONTRATO_PASSOS.DOCUMENTOS,
      MODAL_CRIACAO_DISTRATO_PARAM
    );

    const urlEntePublicoDescentralizado = createDistratoDescentralizadoRoute.getURLWithParams(
      CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO,
      CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
      id,
      CONTRATO_PASSOS.DOCUMENTOS,
      MODAL_CRIACAO_DISTRATO_PARAM
    );

    const urlEntePrivadoDescentralizado = createDistratoDescentralizadoRoute.getURLWithParams(
      CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PRIVADO,
      CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
      id,
      CONTRATO_PASSOS.DOCUMENTOS,
      MODAL_CRIACAO_DISTRATO_PARAM
    );

    const urlCentralizado = contratoDistratoNovoRoute.getURLWithParams(
      getContratoTipoByContratoTipoNumber(tipoContrato),
      id,
      CONTRATO_EDIT_ETAPA_DADOS
    );

    const urlDescentralizadoNum = contratoDistratoNovoRoute.getURLWithParams(
      getContratoTipoByContratoDescentralizadoTipoNumber(tipoContrato),
      id,
      CONTRATO_EDIT_ETAPA_DADOS
    );

    if (
      (tipoContrato === TipoContrato.ASSESSOR ||
        tipoContrato === TipoContrato.ENTE_PUBLICO ||
        tipoContrato === TipoContrato.ENTE_PRIVADO) &&
      tipoFluxo === TipoFluxo.DESCENTRALIZADO
    ) {
      if (window.innerWidth >= 768) {
        openInNewTab(
          tipoContrato === TipoContrato.ASSESSOR ? urlDescentralizado :
            tipoContrato === TipoContrato.ENTE_PUBLICO ? urlEntePublicoDescentralizado :
              urlEntePrivadoDescentralizado
        );
      } else {
        pushToHistory(
          tipoContrato === TipoContrato.ASSESSOR ? urlDescentralizado :
            tipoContrato === TipoContrato.ENTE_PUBLICO ? urlEntePublicoDescentralizado :
              urlEntePrivadoDescentralizado
        );
      }
    } else if (
      window.innerWidth >= 768 &&
      tipoFluxo === TipoFluxo.CENTRALIZADO
    ) {
      openInNewTab(urlCentralizado);
    } else {
      pushToHistory(urlDescentralizadoNum);
    }
  };

  const getTipoNome = () => {
    switch (props.contrato.tipoContrato) {
      case CONTRATO_TIPO_ENTE_PUBLICO:
        return languageValues.contratoTipos[CONTRATO_TIPO_ENTE_PUBLICO_NAME]
          .name;
      case CONTRATO_TIPO_ENTE_PRIVADO:
        return languageValues.contratoTipos[CONTRATO_TIPO_ENTE_PRIVADO_NAME]
          .name;
      case CONTRATO_TIPO_ASSESSOR:
      default:
        return languageValues.contratoTipos[CONTRATO_TIPO_ASSESSOR_NAME].name;
    }
  };

  const getTipoFluxoNome = () => {
    switch (props.contrato.tipoFluxo) {
      case FLUXO_TIPO_TODOS:
        return languageValues.fluxoTipos[FLUXO_TIPO_TODOS_NAME].name;
      case FLUXO_TIPO_DESCENTRALIZADO:
        return languageValues.fluxoTipos[FLUXO_TIPO_DESCENTRALIZADO_NAME].name;
      case FLUXO_TIPO_CENTRALIZADO:
        return languageValues.fluxoTipos[FLUXO_TIPO_CENTRALIZADO_NAME].name;
      default:
        return languageValues.fluxoTipos[FLUXO_TIPO_TODOS_NAME].name;
    }
  };

  const getLabelInformativaContratoItem = useCallback(() => {
    const status = props.contrato.status;
    const ativo = props.contrato.ativo;

    const verificaAditivoEContratosDesativados = () => {
      const todosAditivosInativos = props.contrato.aditivos.every(aditivo => !aditivo.ativo);
      const contratoInativo = !props.contrato.ativo;
      if (!todosAditivosInativos && contratoInativo) {
        return (
          <div className={getMergedClassNames([rootClassName + '-item-label'])}>
            <span className={rootClassName + '-item-value'}>
              {languageValues.contratoNaoFormalizado}
            </span>
          </div>
        );
      }
      return null;
    }

    switch (true) {
      case status === ContratoStatus.EM_EDICAO:
        if (!ativo) {
          const resultado = verificaAditivoEContratosDesativados();
          if (resultado) {
            return resultado;
          }
        }
        return (
          <div className={getMergedClassNames([rootClassName + '-item-label'])}>
            <span className={rootClassName + '-item-value'}>
              {languageValues.contratoNaoFormalizado}
            </span>
          </div>
        );
      case status === ContratoStatus.AGUARDANDO_EXTRATO:
      case status === ContratoStatus.AGUARDANDO_ASSINATURA:
      case status === ContratoStatus.EM_ANALISE:
        return (
          <div className={getMergedClassNames([rootClassName + '-item-label'])}>
            <span className={rootClassName + '-item-value'}>
              {languageValues.contratoNaoFormalizado}
            </span>
          </div>
        );
      case status === ContratoStatus.VIGENTE:
      case status === ContratoStatus.ENCERRADO:
      case status === ContratoStatus.ANALISE_OPERACIONAL_APROVADO:
      case status === ContratoStatus.NAO_INICIADO:
        return getDadosByArr([{
          label: languageValues.cadastroContratoDataFim,
          value: moment(props.contrato.dataFim, 'YYYY MM DD').format('DD/MM/YYYY')
        }]);
      default:
        return languageValues.contratoStatusNaoLocalizada;
    }
  }, [props.contrato,
  languageValues.cadastroContratoDataFim,
  languageValues.contratoNaoFormalizado,
  languageValues.contratoStatusNaoLocalizada]);

  const renderizaTooltipAusenciaDoc = useCallback((title) => (
    <Tooltip
      title={title}
      PopperComponent={Popper}
    >
      <span className={'item-icon color-icon'}>
        <AccordionAlert color={'#E6A500'} />
      </span>
    </Tooltip>
  ), []);

  const verificaAusenciaDocumento = useCallback(() => {
    const docAusente = props.contrato.documentoPendente;
    if (docAusente) {
      return renderizaTooltipAusenciaDoc(languageValues.documentoAusente);
    }
  }, [renderizaTooltipAusenciaDoc,
    languageValues.documentoAusente,
    props.contrato.documentoPendente]);

  return (
    <Row>
      <Col cols={[12, 12, 12, 12, 12]} className={rootClassName + '-col-contrato-item'}>
        <div className={rootClassName}>
          <div className={rootClassName + '-button-items'}>
            <div className={rootClassName + '-tag-tipo-container'}>
              <Tag label={getTipoNome()} theme={PUFV_YELLOW_THEME} />
              &nbsp;
              <Tag label={getTipoFluxoNome()} theme={PUFV_YELLOW_THEME} />
            </div>
            {getDados()}
            {getButtonItems()}
          </div>
          <div className='container-label-icon'>
            <div className={'item-text-right'}>
              {getLabelInformativaContratoItem()}
            </div>
            <div className={getMergedClassNames([rootClassName + '-item-right'])}>
              <div className='item-icone-warning'>
                {verificaAusenciaDocumento()}
              </div>
              {allowGeraAditivo() || allowGeraDistrato() ? (
                <>
                  <button
                    className={rootClassName + '-menu-button'}
                    onClick={toOpenMenu}
                  >
                    <MoreVert />
                  </button>
                  <Menu
                    open={Boolean(menuAnchor)}
                    onClose={toCloseMenu}
                    anchorEl={menuAnchor}
                  >
                    {allowGeraAditivo() ? (
                      <MenuItem
                        onClick={() => {
                          toCloseMenu();
                          criarAditivo();
                        }}
                      >
                        {languageValues.generateAditivo}
                      </MenuItem>
                    ) : null}
                    {allowGeraDistrato() ? (
                      <MenuItem
                        onClick={() => {
                          toCloseMenu();
                          criarDistrato();
                        }}
                      >
                        {languageValues.generateDistrato}
                      </MenuItem>
                    ) : null}
                  </Menu>
                </>
              ) : (
                <span className={rootClassName + '-white-space'} />
              )}
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};
